export default __webpack_public_path__ + "static/media/pause.819b316d.png";